import script from "./external-company-label.vue?vue&type=script&setup=true&lang=ts"
export * from "./external-company-label.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__